﻿import tippy from 'tippy.js';
import moment from 'moment';

var app = window.app;
const BASE_PATH = app.base;

app.printElem = function (selector) {
    var mywindow = window.open('', 'PRINT', 'height=600,width=800');

    jQuery.get(BASE_PATH + "Scripts/bundle/main.css", function (data) {

        mywindow.document.write('<html><head><title>Štampa</title><style>');
        mywindow.document.write(data);
        mywindow.document.write('</style></head><body >');
        mywindow.document.write($(selector).html());
        mywindow.document.write('</body></html>');

        setTimeout(function () {

            mywindow.document.close(); // necessary for IE >= 10
            mywindow.focus(); // necessary for IE >= 10*/

            mywindow.print();
            mywindow.close();
        }, 50);

    });
};

// Date time formatted in time zone
app.dateTimeFormat = function () {
    var dateFields = $("[data-date]");

    if (dateFields.length > 0) {
        dateFields.each(function () {
            var val = $(this).attr("data-date");

            if (val.length > 0) {
                var format = $(this).attr("data-format");
                var value = moment(val);

                var result = "";
                switch (format) {
                    case "date":
                        result = value.format("DD. MMM. YYYY");
                        break;
                    case "time":
                        result = value.format("HH:mm");
                        break;
                    case "datetime":
                        result = value.format("DD. MMM. YYYY, HH:mm");
                        break;
                    case "timedate":
                        result = value.format("DD. MMM. YYYY, HH:mm");
                        break;
                    case "datetimeshort":
                        result = value.format("DD.MM. HH:mm");
                        break;
                    default:
                        result = value.format();
                }

                $(this).html(result);
            }
        });
    }
}
app.dateTimeFormat();


app.formatCurrency = function (amount) {
    return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

var runPopup = function() {
    
    console.log('runPopup function entered');
    var tip = $(".popup-reference-obveznik .reference-choose").attr("data-type"); // obveznik, pdo, zemljiste
    var c = $(".popup-reference-obveznik .reference-choose").parents(".popup-reference-obveznik");
    console.log('tip='+tip);
    console.log('c='+c);
    
    $("#reference-popup-obveznik-component")[0].__vue__.openPrompt(tip, "Kupci", function (result) {

        debugger;

        c.find("input").val(result.Id);
        c.find("input").trigger("change");

        if (c.find(".data-text-field").length > 0) {
            c.find(".data-text-field").html(result.Naziv);
        }

        if (c.find(".data-text-field-input").length > 0) {
            c.find(".data-text-field-input").val(result.Naziv);
        }

        if (c.find(".data-text-field-komitent").length > 0) {
            c.find(".data-text-field-komitent").val(result.Id);
        }

        //if (c.find(".data-text-field-aop").length > 0) {
        //    c.find(".data-text-field-aop").val(result.AOP);
        //}
        //if (document.getElementById("IdPodracunId")!== null) {
        //    document.getElementById("IdPodracunId").value="";
        //    console.log('IdPodracunId set to null');  
        //}
        
        //if (document.getElementById("IdPodracunBTId")!== null) {
        //    document.getElementById("IdPodracunBTId").value="";
        //}
        
        //document.getElementById("nalog-iznos").focus();
    });
};

$(document).ready(function () {

    /*
    window.addEventListener("keyup", function (event) {
        console.log('keyup: '+event.keyCode);
        // Number 13 is the "Enter" key on the keyboard
        if (event.keyCode === 13) {
            console.log('keyup: enter');
            // Cancel the default action, if needed
            event.preventDefault();
            // Trigger the button element with a click
            document.getElementById("submit-stavka-prirez").click();
            document.getElementById("submit-stavka-prirez-izvod").click();
        }
        
        if (event.keyCode === 120) {
            console.log('keyup: F9');
            // Cancel the default action, if needed
           // event.preventDefault();
            runPopup();
            // Trigger the button element with a click
            //document.getElementsByClassName("reference-choose").click();
        }
    });

    $(document).on('keypress', function (e) {
        console.log('keypress: ' + event.keyCode);
        if (e.which === 13 ) {
            console.log('keypress: enter');
            event.preventDefault();
            // Trigger the button element with a click
            document.getElementById("submit-stavka-prirez-izvod").click();
        }
        // 116 = F5  
        else if (e.which === 120 ||  e.keyCode ===13) {
            console.log('keypress: F9');
            runPopup();
            document.getElementsByClassName("reference-choose").click();
            //event.preventDefault();
            // Trigger the button element with a click
            //document.getElementById("submit-stavka-prirez").click();
        }
    });
    */


    $("#nalog-iznos").focusout(function () {
        console.log("nalog-iznos leave focus");
        var x = document.getElementById("nalog-iznos").value;
        if (document.getElementById("nalog-opis") !== null) {
            document.getElementById("nalog-opis").value = "";
        }
        if (x === null || x === "Prirez/GetPrirezByPrihod skip") {
            console.log();
            return;
        }
        //document.getElementById("nalog-opis").value = "" + x;

        $.ajax({
            url: BASE_PATH + "Prirez/GetPrirezByPrihod?value="+x,
            data: x,
            method: "GET"
        //    success: function (data) {
        //        return data;
        //    }
        //}).done(function (data) {
        //    xxx;
        //})
        }).then(function (data) {
            //window.location.reload();
            if (document.getElementById("nalog-opis") !== null) {
                document.getElementById("nalog-opis").value = "" + data;
            }
            if (document.getElementById("iznos") !== null) {
                document.getElementById("iznos").value = "" + data;
            }
            
        }).fail(function (r) {
            //$("#stavke-form-error").html(r);
            if (document.getElementById("nalog-opis") !== null) {
                document.getElementById("nalog-opis").value = "-";
            }
        });
    });
    
    $("#upload_files").change(function() {
        var filename = this.files[0].name;
        console.log("upload_files "+filename);
    });

    $(".submenu-close").click(function() {

        $(".navside li.has-subnav .subnav").each(function() {
            if (!$(this).hasClass("hide")) {
                $(this).addClass("hide");
            }
            return;
        });
        $("#aside").removeClass("submenu-open");
    });

    $("#content").on("click",
        function() {
            if ($("#aside").hasClass("submenu-open")) {
                $(".submenu-close").click();
            }
        });

    $("body").on("click", ".navside li.has-subnav > a",
        function(e) {
            e.preventDefault();
            var aside = $("#aside");
            var link = $(this).parent();

            if (!aside.hasClass("submenu-open")) {
                aside.addClass("submenu-open");
            }

            if (!link.find(".subnav").hasClass("hide")) {
                link.find(".subnav").addClass("hide");
                aside.removeClass("submenu-open");
                return;
            }

            $(".navside .nav > li.has-subnav").find(".subnav").addClass("hide");
            link.find(".subnav").removeClass("hide");
        });

    // generic back button 
    $("body").on("click",
        ".titlebar-back-button",
        function (e) {
            if (!$(this).hasClass("no-redirect")) {
                window.location = document.referrer;
                return false;
            }
        });

    // entity form pretty checkbox
    $("body").on("change", ".entity-form .md-check input", function () {
        var name = $(this).attr("data-name");
        var val = $(this).prop('checked');

        if ($(this).attr("data-bit") === "true") {
            // fix for bit values
            $(this).parents('form').find("[name='" + name + "']").val(val ? "1" : "0");
        } else {
            $(this).parents('form').find("#" + name).prop('checked', val);
        }
    });


    // generic export modal & download
    $("#export-button").click(function (e) {
        e.preventDefault();
        $("#modal-export").attr("data-url", $(this).attr("href"));
        $("#modal-export").attr("data-form-selector", $(this).attr("data-form-selector"));
        $("#modal-export").modal("show");
    });


    $("#export-download").click(function () {

        if (!$("#modal-export").attr("data-url")) {
            return;
        }
        var url = $("#modal-export").attr("data-url");

        if ($(".col-select[data-value='True']").length === 0) {
            $("#export-columns-form .validation").show();
            return false;
        }


        var formSel = $("#modal-export").attr("data-form-selector");

        if (!formSel || formSel.length < 1) {
            formSel = ".tab-content form";
        }

        var data = $(formSel).serialize();

        if (data.length > 0 || url.indexOf("?") > -1)
            data += "&";

        var excludeColumns = [];

        $(".col-select").each(function () {
            if ($(this).attr("data-value") === "False") {
                excludeColumns.push($(this).attr("data-col-name"));
            }
        });

        if (excludeColumns.length > 0) {
            data += "exclude=" + excludeColumns.join();
        }

        url = url.indexOf("?") > -1 ? url : url + "?";
        window.location.href = url + data;
    });

    $(".col-select").click(function () {
        if (!$("#modal-export").attr("data-url")) {
            return;
        }
        if ($(this).attr("data-value") === "True") {
            $(this).attr("data-value", "False");
        } else {
            $(this).attr("data-value", "True");
            $("#export-columns-form .validation").hide();
        }
    });

    
    tippy("body",
        {
            target: ".tippy-link",
            placement: "right",
            arrow: true,
            delay: [300, 0]
        });

    

    $(document).on('click', '.keepopen .dropdown-menu', function (e) {
        e.stopPropagation();
    });

    // theme switcher
    $("#theme-change").change(function() {
        var name = $(this).val();

        $.post(BASE_PATH + "Account/SetTheme", { theme: name }).then(function() {
            window.location.reload();
        });
    });

    // conirmation modals
    $("body").on('click', '[data-confirmation]', function (e) {
        e.preventDefault();
        var content = $(this).find("[data-confirmation-content]");

        content.each(function () {
            var name = $(this).attr("data-confirmation-content");
            var value = $(this).html();

            $("#modal-confirm").find("[data-content='" + name + "']").html(value);
        });

        $("#modal-confirm").modal("show");
    });

    $("#modal-confirm").on("click",
        ".modal-content .btn.primary",
        function () {
            $(".modal-content").find("form").submit();
        });


    // Price calculation listeners - for transaction modals
    $("body").on("change",
        ".price-calculate .amount, .price-calculate .fee, .price-calculate .driver-amount",
        function () {

            var form = $(this).parents("form");

            var changed = $(this).attr("data-name");

            var amount = form.find("input.amount"),
                fee = form.find("input.fee"),
                driverAmount = form.find("input.driver-amount"),
                stripe = form.find("input.stripe-fee"),
                fetchit = form.find("input.fetchit-fee"),
                tip = form.find("input.tip-amount");


            var values = {
                amount: parseFloat(amount.val()),
                fee: parseFloat(fee.val()),
                driverAmount: parseFloat(driverAmount.val()),
                stripe: parseFloat(stripe.val()),
                fetchit: parseFloat(fetchit.val()),
                tip: tip.length > 0 ? parseFloat(tip.val()) : 0
            };

            if (changed === "amount" || changed === "fee") {
                var newDriverAmount = (values.amount - values.tip) * (1 - values.fee / 100) + values.tip;
                values.driverAmount = newDriverAmount;
            }

            debugger;
            if (changed === "driver-amount") {
                var newFee = (1 - (values.driverAmount - values.tip) / (values.amount - values.tip)) * 100;
                values.fee = newFee;
            }

            values.stripe = values.amount * 0.029 + 0.3;

            values.fetchit = values.amount - values.stripe - values.driverAmount;

            amount.val(values.amount.toFixed(2));
            fee.val(values.fee.toFixed(4));
            driverAmount.val(values.driverAmount.toFixed(2));
            fetchit.val(values.fetchit.toFixed(2));
            stripe.val(values.stripe.toFixed(2));
        });

    

       $("body").on("click", ".popup-reference-field .reference-choose", function (e) {
        
        e.preventDefault();

        var c = $(this).parents(".popup-reference-field");
        var controller = c.data('controller');
        var modalTitle = $(this).attr("data-original-title");

        $("#reference-popup-component")[0].__vue__.openPrompt(controller, modalTitle, function(result) {
            if (result.valueChanged) {
                c.find("input").val(result.newValue);
                c.find(".data-text-field").html(result.newValueText);

            }
        });
    });

    $("body").on("click", ".popup-reference-katastar-button", function (e) {
        e.preventDefault();

        var tip = $(this).attr("data-type"); // obveznik, pdo, zemljiste

        $("#reference-popup-katastar-component")[0].__vue__.openPrompt(tip, "Katastarski podaci", function(result) {

            var fields = {};
            console.log('VPL:', 'VPL');
            console.log('VPL value:', result.BrLista);

            if (tip === "obveznik") {
                fields = {
                    "#KatastarMaticniBroj": result.JMBG,
                    "#kt_naziv": result.Naziv,
                    "#kt_adresa": result.Ulica,
                    "#kt_srez": "BARSKI SREZ",//result.,
                    "#kt_ko": result.KatastarskaOpstina,
                    "#kt_aktivan": "Da",
                    "#kt_svojina": result.Pravo,
                    "#kt_naselje": result.Ulica,
                    "#kt_tip": result.Tip
                };
            }

            if (tip === "pdo") {
                fields = {
                    "#VSrezId": "15",
                    "#VKO": result.IdKatastarskaOpstina,
                    "#VBroj": result.Broj,
                    "#VPodbroj": result.Podbroj,//result.,
                    "#VKultura": "",
                    "#VZgrada": result.BrojZgrade,
                    "#VStan": "",
                    "#VPL": result.BrLista,
                    "#VIndPL": "",
                    "#VPU": "",
                    "#kt_povrsina": result.Povrsina,
                    "#kt_god_izgradnje": result.GodinaIzgr,
                    "#kt_ulaz": "",
                    "#kt_stan_orig": "",
                    "#kt_sprat": result.IdSprat
                };
            }

            if (tip === "zemljiste") {
                fields = {
                    "#ParcelaSrezId": "15",
                    "#ParcelaKOId": result.IdKatastarskaOpstina,
                    "#ParcelaBroj": result.Broj,
                    "#ParcelaPodbroj": result.Podbroj,//result.,
                    "#ParcKultura": "",
                    "#ParcKlasa": "",
                    "#ParcZgrada": "",
                    "#ParcGodSP": "",
                    "#ParcSP": "",
                    "#kt_povrsina": result.Povrsina,
                    "#kt_pl": result.BrLista,
                    "#kt_indpl": "",
                    "#kt_potes": result.Potes,
                    "#kt_skica": result.Skica,
                    "#kt_karta": result.PlanParcele
                };
            }

            // na osnovu tipa, popuniti polja u formi

            for (var prop in fields) {
                var field = $(prop);
                field.val(fields[prop]);
                field.change();
            }
        });
    });

    $('#IdPodracunId').on('change', function() {
        var val = document.getElementById("IdPodracunId").value;
        if (val !== null && val !== "") {
            loadZaduzenjaBTPoObjektu(val);
        }
        
    });
    

    $("body").on("click", ".popup-reference-datum-generisanja-button", function (e) {
        e.preventDefault();

        var tip = $(this).attr("data-type"); // PDO, PDOPravna, ZEM, TT

        $("#reference-popup-datum-generisanja-component")[0].__vue__.openPrompt(tip, "Datumi generisanja", function (result) {
            if (result) {
                var god = result.Godina;
                var datum = result.Datum;

                var date = moment(datum);

                $("#DatumZaduzenja").val(date.format("YYYY-MM-DD"));
                $("#Godina").val(date.format("YYYY"));
            }
        });
    });


    var loadZaduzenjaBTPoObjektu = function(idObjekat) {
        $.ajax({
            url: BASE_PATH + "BTNalog/GetZaduzenjaZaObjekat?idObjekat="+idObjekat,
            //data: x,
            method: "GET"
        }).then(function (data) {
            console.log("loadZaduzenjaBTPoObjektu: set select list.");
            console.log('array data: ' + data.length);
            //console.log('array: ' + data);
                        
           
            var select = document.getElementById("IdPodracunBTId");
            select.innerHTML = "";

            for (var ind = 0; ind < data.length; ++ind) {
                //console.log('ind: ' + ind);
                select.innerHTML += "<option value=\"" + data[ind].IdStavkaNaloga + "\">" + data[ind].Value + "</option>";
            }
                          
                        
        }).fail(function (r) {
            console.log("reference-popup-obveznik: Failed to load podracun.");
        });

    };
    
    $("body").on("click", ".popup-reference-obveznik .reference-choose", function (e) {
        e.preventDefault();
        var tip = $(".popup-reference-obveznik .reference-choose").attr("data-type"); // obveznik, pdo, zemljiste
        var c = $(".popup-reference-obveznik .reference-choose").parents(".popup-reference-obveznik");
        
        $("#reference-popup-obveznik-component")[0].__vue__.openPrompt(tip, "Kupci", function (result) {
            c.find("input").val(result.Id);
            c.find("input").trigger("change");

            if (c.find(".data-text-field").length > 0) {
                c.find(".data-text-field").html(result.Naziv);
            }
        });
        
    });

    var artikalForm = $(".artikal-add-edit");

    if (artikalForm.length > 0) {
        var cijenaBezPdv = artikalForm.find("input[name='CijenaVP']");

        var poreskaStopa = parseFloat(artikalForm.find("select[name='PoreskaStopaId'] :selected").text());

        var cijena = artikalForm.find("input[name='Cijena']");

        
    }

    $("body").on("change", ".artikal-add-edit input[name='CijenaVP'], .artikal-add-edit select[name='PoreskaStopaId']", function () {
        var cijenaBezPdv = parseFloat($(".artikal-add-edit input[name='CijenaVP']").val());
        var poreskaStopa = parseFloat($(".artikal-add-edit select[name='PoreskaStopaId'] :selected").text());

        var tot = cijenaBezPdv * (1 + (poreskaStopa / 100));
        $(".artikal-add-edit input[name='Cijena']").val(tot.toFixed(2));
    });

    $("body").on("change", ".artikal-add-edit input[name='Cijena']", function () {
        var cijenaSaPdv = parseFloat($(".artikal-add-edit input[name='Cijena']").val());
        var poreskaStopa = parseFloat($(".artikal-add-edit select[name='PoreskaStopaId'] :selected").text());

        var cijenaBezPdv = cijenaSaPdv / (1 + (poreskaStopa / 100));
        $(".artikal-add-edit input[name='CijenaVP']").val(cijenaBezPdv.toFixed(2));
    });


    var formRow = $(".stavke-form-row");

    if (formRow.length > 0) {
        //var obv = formRow.find('input[name="ObveznikId"]');

        //obv.change(function () {
        //    $(".popup-reference-pdo .reference-choose, .popup-reference-zemljiste .reference-choose").removeClass("disabled");
        //});

        $("#submit-stavka").click(function () {

            $("#stavke-form-error").html("");

            var values = {};
            formRow.find("input, select").each(function () {
                values[$(this).attr("name")] = $(this).val();
            });
            $.ajax({
                url: BASE_PATH + "Dokument/PostStavka",
                data: values,
                method: "POST"
            }).then(function (response) {
                if (response.uri) {
                    window.location.href = BASE_PATH + response.uri;
                } else {
                    window.location.reload();
                }

            }).fail(function (r) {
                $("#stavke-form-error").html(r);
            });
        });

        // Na promjenu Kolicina, CijenaKomad, Rabat i PoreskaStopaId preracunati ukupno
        formRow.on("change", "input[name='Kolicina'], input[name='CijenaKomad'], input[name='Popust'], select[name='PoreskaStopaId']", function () {
            var kolicina = parseFloat(formRow.find("input[name='Kolicina']").val());
            var cijenaKomad = parseFloat(formRow.find("input[name='CijenaKomad']").val());
            var popust = parseFloat(formRow.find("input[name='Popust']").val());
            var poreskaStopa = parseFloat(formRow.find("select[name='PoreskaStopaId'] :selected").text());

            if (cijenaKomad && kolicina) {
                var cijenaBezPdv = kolicina * cijenaKomad;

                var cijenaSaPopustom = popust ? cijenaBezPdv * (1 - (popust/100)) : cijenaBezPdv;

                var ukupno = cijenaSaPopustom * (1 + (poreskaStopa/100));

                formRow.find("input[name='CijenaSaPDV']").val(ukupno.toFixed(2));
            }
        });


        $("#submit-stavka-prirez-izvod").click(function () {

            $("#stavke-form-error").html("");

            console.log('submit-stavka-prirez-izvod: start');

            var values = {};
            formRow.find("input").each(function () {
                values[$(this).attr("name")] = $(this).val();
            });
            console.log('submit-stavka-prirez-izvod: ajax call');

            $.ajax({
                url: BASE_PATH + "NalogIzvod/PostStavkaIzvoda",
                data: values,
                method: "POST"
            }).then(function () {
                $("#stavke-form-error-block").removeClass("hide");
                $("#stavke-form-error-block").addClass("hide");
                window.location.reload();
            }).fail(function (r) {//xhr, textStatus, errorThrown) {
                console.log('submit-stavka-prirez: ajax-error: ' + r.responseText);
                $("#stavke-form-error-block").removeClass("hide");
                $("#stavke-form-error").html(r.responseText);
                console.log(r.responseText);
            });
        });
        
        $("#submit-stavka-bt-izvod").click(function () {

            $("#stavke-form-error").html("");

            console.log('submit-stavka-bt-izvod: start');

            var values = {};
            formRow.find("input").each(function () {
                values[$(this).attr("name")] = $(this).val();
            });
            formRow.find("select").each(function () {
                values[$(this).attr("name")] = $(this).val();
            });

            
            console.log('submit-stavka-prirez-izvod: ajax call');

            $.ajax({
                url: BASE_PATH + "BTNalog/PostStavkaIzvoda",
                data: values,
                method: "POST"
            }).then(function () {
                $("#stavke-form-error-block").removeClass("hide");
                $("#stavke-form-error-block").addClass("hide");
                window.location.reload();
            }).fail(function (r) {//xhr, textStatus, errorThrown) {
                console.log('submit-stavka-prirez: ajax-error: ' + r.responseText);
                $("#stavke-form-error-block").removeClass("hide");
                $("#stavke-form-error").html(r.responseText);
                console.log(r.responseText);
            });
        });
        
        $("#submit-stavka-prirez").click(function () {

            $("#stavke-form-error").html("");

            console.log('submit-stavka-prirez: start');

            var values = {};
            formRow.find("input").each(function () {
                values[$(this).attr("name")] = $(this).val();
            });
            console.log('PrirezObrac = ' + values["PrirezObrac"]);
            values["PrirezObrac"] = values["PrirezObrac"].replace(',', '');
            values["Iznos"] = values["Iznos"].replace(',', '');
            
            console.log('PrirezObrac/Iznos Edited= ' + values["PrirezObrac"] + '/' + values["Iznos"]);
            console.log('submit-stavka-prirez: ajax call');

            $.ajax({
                url: BASE_PATH + "Prirez/ZaduzenjePrireza",
                data: values,
                method: "POST"
            }).then(function () {
                $("#stavke-form-error-block").removeClass("hide");
                $("#stavke-form-error-block").addClass("hide");
                window.location.reload();
            }).fail(function (r) {//xhr, textStatus, errorThrown) {
                console.log('submit-stavka-prirez: ajax-error: ' + r.responseText);
                $("#stavke-form-error-block").removeClass("hide");
                $("#stavke-form-error").html(r.responseText);
                //console.log(r.promise.responseText);
                console.log(r.responseText);
                //JSON.stringify(r);
                //console.log(errorThrown);
                //r.Error
                //window.location.reload();
            });
        });
    }

    $("body").on("click", ".popup-reference-zemljiste .reference-choose", function (e) {
        e.preventDefault();

        var tip = $(this).attr("data-type"); // obveznik, pdo, zemljiste
        var c = $(this).parents(".popup-reference-zemljiste");

        var obveznikId = $('input[name="ObveznikId"]').val();

        $("#reference-popup-zemljiste-component")[0].__vue__.openPrompt(obveznikId, "Zemljište obveznika", function (result) {

            c.find("input").val(result.Id);
            c.find(".data-text-field").html(result.Oznaka);

            $(".popup-reference-pdo input").val("");
            $(".popup-reference-pdo .data-text-field").html("Pronađi");
        });
    });

    $("body").on("click", ".popup-reference-pdo .reference-choose", function (e) {
        e.preventDefault();
       

        var c = $(this).parents(".popup-reference-pdo");
        
        $("#reference-popup-pdo-component")[0].__vue__.openPrompt(0, 1, false, "Artikli", function (result) {
            
            var item = result.item;

            c.find("input[name='ArtikalId']").val(item.Id);
            c.find("input[name='Sifra']").val(item.Sifra);
            c.find(".data-text-field").html(item.Sifra ? item.Sifra : "-");

            var formRow = c.parents('.stavke-form-row');

            formRow.find("input[name='Naziv']").val(item.Naziv);

            formRow.find("select[name='OznakaJM']").val(item.JedinicaMjere);

            formRow.find("input[name='CijenaKomad']").val(item.CijenaBezPdv);
            formRow.find("select[name='PoreskaStopaId']").val(item.IdPdv); 

            // da bi trigerovao preracunavanje ukupne cijene
            formRow.find("input[name='CijenaKomad']").trigger("change");

            //c.find(".data-text-field").html(pfx + result.item.Oznaka);
        });
    });


    $("body").on("click", "#clanovi-domacinstva-prepis", function () {
        var form = $(this).parents("form");
        var inputs = form.find("input[name='Ime'], input[name='Prezime'], input[name='ImeOca']");
        inputs.val("prepis");
    });

    $("body").on("click",
        ".button-pdf-print",
        function(e) {
            e.preventDefault();

            //$("#modal-loading").modal("show");

            //if ($("#pdf").length > 0) {
            //    $("#pdf").parent().remove();
            //}

            var src = $(this).attr("href");

            window.open(src);

            //var tpl = '<div class="hide"><div id="pdf" style="width: 100%; height: 100%;">' +
            //    '<iframe src="'+src+'" name="pdfFrame" style="width: 100%; height: 100%;" frameborder="0" scrolling="no">' +
            //    '<p>It appears your web browser doesn\'t support iframes.</p>' +
            //    '</iframe>' +
            //    '</div></div>';

            //var tplEls = $(tpl);

            //$("body").append(tplEls);


            //tplEls.find("iframe").on("load",
            //    function () {
                    
            //        if (this.contentDocument.URL.indexOf("Login") > -1) {
            //            $("#modal-loading").modal("hide");
            //            alert("Sesija je istekla - ponovo se prijavite na sistem");
            //        } else {
                        
            //            window.frames["pdfFrame"].focus();
            //            window.frames["pdfFrame"].print();

            //        $("#modal-loading").modal("hide");
            //        }

            //    });

            
        });


    $("body").on("click", ".global-year-filter .dropdown-menu a", function () {
        $.get(BASE_PATH + "Home/SetGlobalFilter", { value: $(this).attr("data-val") }).then(function () {
            location.reload();
            //window.location.href = BASE_PATH;
        });
    });

    $("body").on("click", ".global-tax-type-filter .dropdown-menu a", function () {
        $.get(BASE_PATH + "Home/SetGlobalTaxTypeFilter", { value: $(this).attr("data-val") }).then(function () {
            window.location.href = BASE_PATH;
            //location.reload();
        });
    });



    /* PRENOS VLASNISTVA */
    var stariObvezniciBtn = $(".prenos-stari-obveznici .select-all-td");
    if (stariObvezniciBtn.length > 0) {
        stariObvezniciBtn.change(function (e) {
            var checked = $(this).prop("checked");
            $(".prenos-stari-obveznici tbody input[type='checkbox']").each(function () {
                $(this).prop("checked", checked)
                $(this).change();
            });
        });

        $(".prenos-stari-obveznici tbody input[type='checkbox']").change(function () {
            var total = $(".prenos-stari-obveznici tbody input[type='checkbox']").length;
            var checked = $(".prenos-stari-obveznici tbody input[type='checkbox']:checked").length;

            if (total > checked) { 
                stariObvezniciBtn.prop("checked", false);
            } else {
                stariObvezniciBtn.prop("checked", true);
            }
        });
    }

    var stavkePrenosaForm = $(".stavke-prenosa-form-row");
    if (stavkePrenosaForm.length > 0) {
        stavkePrenosaForm.find("input[type='submit']").on('click', function () {
            var idPrenos = $(this).attr('data-id-prenos');

            var obveznikId = stavkePrenosaForm.find("input[name='ObveznikId']").val();
            var punoIme = stavkePrenosaForm.find("input[name='PunoIme']").val();
            var aop = stavkePrenosaForm.find("input[name='AOP']").val();
            var udio1 = stavkePrenosaForm.find("input[name='Udio1']").val();
            var udio2 = stavkePrenosaForm.find("input[name='Udio2']").val();

            var vlasniciIdList = [];
            $(".prenos-stari-obveznici tbody :checked").each(function () {
                vlasniciIdList.push($(this).attr("data-id"));
            });

            $.ajax({
                url: BASE_PATH + 'PNPrenosVlasnistva/PostStavka',
                method: "POST",
                data: {
                    prenosId: idPrenos,
                    obveznikId: obveznikId,
                    punoIme: punoIme,
                    aop: aop,
                    udio1: udio1,
                    udio2: udio2,
                    vlasniciIdList: vlasniciIdList.join(",")
                }
            }).then(function () {
                window.location.reload();
            });
        });
    }



/* COMPANY SWITCHER */
    var companySwitcher = $("#global-company-switcher");
    companySwitcher.on('click', '.nav-link', function () {
        companySwitcher.find('.dropdown-menu').html('<div class="infinite-loading loading"></div>');
        $.ajax({
            url: BASE_PATH + 'Home/GetCompanyList',
            method: 'GET'
        }).then(function (response) {
            companySwitcher.find('.dropdown-menu').html(response);
        }).catch(function () {

        });
    });

    companySwitcher.on('click', '.dropdown-item', function () {
        var id = $(this).attr("data-val");
        $.ajax({
            url: BASE_PATH + 'Home/SetCompanyId',
            method: 'POST',
            data: {
                companyId: id
            }
        }).always(function (resp) {
            window.location.href = BASE_PATH + 'Home/Index';
        })
    });

    var languageSwitcherItems = $(".navbar-language-dropdown .dropdown-item.lang-item");
    languageSwitcherItems.click(function () {
        var lang = $(this).attr("data-lang");
        $.ajax({
            url: BASE_PATH + 'Home/SetUserLanguage',
            method: 'POST',
            data: {
                language: lang
            }
        }).always(function (resp) {
            window.location.reload();
        });
    });

});


export default app;